import { useEffect } from 'react';

/**
 * A hook to find the first interactive element on the page.
 * Is used for accessability, so when you use the tab-key to navigate the flow, you'll start att the first interactive element on the page
 * @param pageIndex an optional parameter to trigger the useEffect when we change page
 */

export const usePageFocus = (pageIndex?: number) => {
    useEffect(() => {
        const firstElement = document.querySelector('input, select, textarea, button, a') as HTMLElement;
        firstElement?.focus();
    }, [pageIndex]);
};
